exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-efae7{background-color:#65d0a7;border-radius:100%;color:#fff;height:4.4rem;margin:2.4rem 0 1.8rem 0;width:4.4rem}", ""]);

// Exports
exports.locals = {
	"icon": "icon-efae7"
};